import { useTransition } from '@react-spring/web';
import { createArrayNumbers } from '@uikit/utils/createArrayNumbers';
import { useMemo, useRef, useState } from 'react';
import { createYearQuarter, dateToYearQuarter } from './helpers';

export const useQuarter = () => {
  const [quarterIndex, setQuarterIndex] = useState(0);

  const quarterList = useMemo(() => {
    const currentYearQuarter = dateToYearQuarter(new Date());

    return createArrayNumbers(4, 0).map((quarterNumber) =>
      createYearQuarter(currentYearQuarter, quarterNumber)
    );
  }, []);

  const quarter = quarterList[quarterIndex];

  const canNextQuarter = quarterIndex < quarterList.length - 1;

  const canPrevQuarter = quarterIndex > 0;

  const nextQuarter = () => {
    setQuarterIndex((value) => Math.min(quarterList.length - 1, value + 1));
  };

  const prevQuarter = () => {
    setQuarterIndex((value) => Math.max(0, value - 1));
  };

  const useRefPrevIndex = useRef(-1);

  const quarterTransitions = useTransition(quarterIndex, {
    from: {
      transform: `translateX(${
        useRefPrevIndex.current > quarterIndex ? '-' : ''
      }100%)`,
      opacity: 1,
      position: 'relative',
    } as const,
    enter: {
      transform: 'translateX(0%)',
      opacity: 1,
      position: 'relative',
    } as const,
    leave: {
      transform: `translateX(${
        useRefPrevIndex.current < quarterIndex ? '-' : ''
      }100%)`,
      opacity: 0,
      position: 'absolute',
      width: '100%',
    } as const,
    onDestroyed: () => {
      useRefPrevIndex.current = quarterIndex;
    },
  });

  return {
    quarter,
    quarterIndex,
    nextQuarter,
    prevQuarter,
    canNextQuarter,
    canPrevQuarter,
    quarterList,
    quarterTransitions,
  };
};
